import Vue from 'vue';
import Router from 'vue-router';
import AddRouter from '@/pages/router-manage/AddRouter';
import Authority from '@/router/module/authoritymanage';
import UserManage from '@/router/module/usermanage';
import BusinessManage from '@/router/module/businessmanage';
import OrderManage from '@/router/module/order-manage';
import ServiceManage from '@/router/module/service-manage';
import ContentManage from '@/router/module/content-manage';
import RechargeManage from '@/router/module/recharge-manage';
import FinanceManage from '@/router/module/finance-manage';
import MemberManage from '@/router/module/member-manage';
import TagManage from '@/router/module/tag-manage';
const Login = () => import('@/pages/Login');
const Index = () => import('@/pages/Index');
import Pagination from '@/components/CommonPagination'
Vue.use(Router);

const children = [
  ...Authority,
  ...UserManage,
  ...BusinessManage,
  ...OrderManage,
  ...ServiceManage,
  ...ContentManage,
  ...RechargeManage,
  ...FinanceManage,
  ...MemberManage,
  ...TagManage,
]

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/login',
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/index',
      component: Index,
      children,
    }
    ,
    {
      path: '/addrouter',
      component: AddRouter
    }
  ],
  // mode: 'history',
});

export default router;
